// TODO: move to sanity Site Settings schema
export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_ASM_CUSTOMER_SEARCH_PAGE_SIZE = 20
export const CONTRACTED_PRODUCTS_CATEGORY_ID = '10900'
export const MAX_ITEMS_PER_MENU_LEVEL = 8
export const QUICK_SEARCH_MIN_TERM_LENGTH = 3
export const PAGE_SIZE_DEFAULT = 25
export const FAVORITE_LIST_PAGE_SIZE_DEFAULT = 100
export const PAGE_SIZE_MAX = 2147483647
export const REQUEST_TIMEOUT = 15000
export const SSR_PRODUCT_FETCH_TIMEOUT = 5000 // must stay under REQUEST_TIMEOUT
export const SSR_EBOX_FETCH_TIMEOUT = 5000 // must stay under REQUEST_TIMEOUT
export const SSR_TRUSTED_TOKEN_FETCH_TIMEOUT = 2000 // must stay under SSR_PRODUCT_FETCH_TIMEOUT
export const SSR_SANITY_FETCH_TIMEOUT = 10000 // must stay under REQUEST_TIMEOUT
export const SANITY_LAST_KNOWN_GOOD_TTL_MS = 24 * 60 * 60 * 1000 // 24h
export const LAST_KNOWN_GOOD_REDIS_TIMEOUT_MS = 2500

export const CMS_CACHE_LIFE_STALE_SECONDS = 60 * 5
export const CMS_CACHE_LIFE_REVALIDATE_SECONDS = 60 * 60 * 12
export const CMS_CACHE_LIFE_EXPIRE_SECONDS = 60 * 60 * 24 * 3
export const CMS_CACHE_LIFE_REVALIDATE_JITTER_SECONDS = 60 * 15
export const LAST_KNOWN_GOOD_CACHE_LIFE_SECONDS = 60
export const SAP_REFRESH_TOKEN_FETCH_TIMEOUT = 4000 // must stay under LOCK_TTL_MS in refresh-access-token.ts
export const SANITY_REFERENCE_LOOKUP_TIMEOUT = 5000 // webhook-only; must stay under REQUEST_TIMEOUT

// TODO: lower once SAP fixes catalog endpoint latency
export const CATALOG_REQUEST_TIMEOUT = 30000
export const SSR_CATALOG_FETCH_TIMEOUT = 25000 // must stay under CATALOG_REQUEST_TIMEOUT

// Hard cap on the server-side query cache (per-pod L1 for ecom reads).
// Bounds the customerId-keyed keyspace so the heap cannot grow unbounded.
export const SSR_QUERY_CACHE_MAX_ENTRIES = 1000
